import React from 'react';
import { Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

const LoginForm = ({ onFinish, isLoadingLogin, handleForgotPassword }) => {
  return (
    <Form
      name="login"
      className="login-form"
      initialValues={{ remember: true }}
      onFinish={onFinish}
    >
      <Form.Item
        name="username"
        rules={[
          {
            required: true,
            message: 'กรุณาใส่ชื่อผู้ใช้',
          },
          {
            type: 'string',
            //message: 'กรุณากรอกฟอร์แมตอีเมลที่ถูกต้อง!',
          },
        ]}
      >
        <Input
          prefix={<UserOutlined className="site-form-item-icon h-10" />}
          placeholder="ชื่อผู้ใช้"
        />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[{ required: true, message: "กรุณาใส่รหัสผ่านของคุณ!" }]}
      >
        <Input.Password
          prefix={<LockOutlined className="site-form-item-icon h-10" />}
          type="password"
          placeholder="รหัสผ่าน"
        />
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="login-form-button w-full h-10 text-lg"
          loading={isLoadingLogin}
        >
          เข้าสู่ระบบ
        </Button>
      </Form.Item>

      {/* เดิม comment ทิ้งไว้เพราะปลายทาง /forget-password ไม่เคยมีอยู่จริง
          ตอนนี้ทำเป็นขั้นตอนในหน้า login แล้ว (ยืนยันด้วยรหัส 6 หลัก) จึงเปิดใช้ได้
          htmlType ต้องเป็น button — ถ้าปล่อยให้เป็น submit จะไปยิง login แทน */}
      <Form.Item className="mb-0">
        <Button
          type="link"
          htmlType="button"
          className="w-full"
          onClick={handleForgotPassword}
        >
          ลืมรหัสผ่าน?
        </Button>
      </Form.Item>
    </Form>
  );
};

export default LoginForm;
